export default "Fonds décarbonation industrie — France 2030, Bpifrance, ADEME | Solution Éco France";
